import OpsLayout from '../../components/layout/OpsLayout';
import DeptMessages from '../../components/DeptMessages';

export default function OpsMessagesPage() {
  return (
    <OpsLayout>
      <DeptMessages dept="Operations" color="blue" testPrefix="ops" />
    </OpsLayout>
  );
}
